import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-dark text-gray-400 py-10 text-center text-sm border-t border-white/10" data-id="element-65">
        <div className="max-w-4xl mx-auto px-6" data-id="element-66">
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-67">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-gold transition-colors duration-200 underline underline-offset-4 decoration-gray-600 hover:decoration-gold" data-id="element-68">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-69">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-gold transition-colors duration-200 underline underline-offset-4 decoration-gray-600 hover:decoration-gold" data-id="element-70">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-71">
            © {new Date().getFullYear()} Legado Digital Seguro. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-60" data-id="element-72">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-73">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-74">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 bg-cream flex-shrink-0" data-id="element-75">
              <h2 className="text-2xl font-bold text-navy-dark font-serif" data-id="element-76">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-navy-dark transition-colors p-1 rounded-full hover:bg-gray-100" aria-label="Cerrar" data-id="element-77">
                <X className="w-6 h-6" data-id="element-78" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-8 py-6 overflow-y-auto text-left text-gray-700 text-base leading-relaxed space-y-5" data-id="element-79">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-80" /> : <TermsContent data-id="element-81" />}
            </div>

            {/* Modal Footer */}
            <div className="px-8 py-4 border-t border-gray-200 bg-gray-50 flex-shrink-0" data-id="element-82">
              <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-navy text-white font-bold rounded-lg hover:bg-navy-dark transition-colors" data-id="element-83">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-gray-500 italic" data-id="element-84">
        Última actualización: marzo 2026
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-85">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-86">
        Al adquirir nuestros productos digitales, recopilamos únicamente la
        información necesaria para procesar tu compra, incluyendo: nombre,
        dirección de correo electrónico y datos de pago. No almacenamos
        información de tarjetas de crédito directamente; todos los pagos son
        procesados por plataformas de pago seguras de terceros.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-87">
        2. Uso de la Información
      </h3>
      <p data-id="element-88">Utilizamos tu información personal exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-89">
        <li data-id="element-90">Procesar y entregar tu compra digital.</li>
        <li data-id="element-91">Enviarte el producto adquirido y actualizaciones relacionadas.</li>
        <li data-id="element-92">
          Responder a consultas o solicitudes de soporte que nos envíes
          voluntariamente.
        </li>
      </ul>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-93">
        3. Protección de Datos
      </h3>
      <p data-id="element-94">
        Implementamos medidas de seguridad técnicas y organizativas razonables
        para proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Sin embargo, ningún método de
        transmisión por Internet es 100% seguro.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-95">
        4. Compartir Información con Terceros
      </h3>
      <p data-id="element-96">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de pago
        necesarios para completar tu transacción, quienes están obligados a
        mantener la confidencialidad de tus datos.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-97">
        5. Cookies y Tecnologías de Seguimiento
      </h3>
      <p data-id="element-98">
        Este sitio puede utilizar cookies y tecnologías similares para mejorar
        la experiencia del usuario y analizar el tráfico del sitio. Puedes
        configurar tu navegador para rechazar cookies, aunque esto podría
        afectar algunas funcionalidades.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-99">
        6. Tus Derechos
      </h3>
      <p data-id="element-100">
        Tienes derecho a acceder, corregir o solicitar la eliminación de tus
        datos personales en cualquier momento. También puedes optar por no
        recibir comunicaciones de marketing futuras.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-101">
        7. Cambios a esta Política
      </h3>
      <p data-id="element-102">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-gray-500 italic" data-id="element-103">
        Última actualización: marzo 2026
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-104">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-105">
        Al realizar una compra en este sitio, aceptas estos términos y
        condiciones en su totalidad. Si no estás de acuerdo con alguna parte de
        estos términos, te pedimos que no realices la compra.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-106">
        2. Producto Digital
      </h3>
      <p data-id="element-107">
        El producto ofrecido es un recurso educativo en formato digital (PDF y
        plantillas descargables). El contenido tiene fines informativos y
        educativos. No constituye asesoría legal, financiera ni tecnológica
        profesional. Recomendamos consultar con profesionales especializados
        para situaciones específicas.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-108">
        3. Entrega del Producto
      </h3>
      <p data-id="element-109">
        Una vez confirmado el pago, recibirás acceso inmediato al producto
        digital a través de un enlace de descarga enviado a tu correo
        electrónico. Es tu responsabilidad proporcionar una dirección de correo
        válida y verificar tu bandeja de entrada, incluyendo la carpeta de spam.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-110">
        4. Licencia de Uso
      </h3>
      <p data-id="element-111">
        Al adquirir el producto, obtienes una licencia personal e intransferible
        para uso propio y de tu núcleo familiar directo. Queda prohibida la
        reproducción, distribución, reventa o compartición del material con
        terceros fuera de tu hogar.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-112">
        5. Garantía de Satisfacción
      </h3>
      <p data-id="element-113">
        Ofrecemos una garantía de satisfacción. Si no estás conforme con el
        producto, puedes solicitar un reembolso completo dentro de los 30 días
        posteriores a la compra, sin necesidad de justificación.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-114">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-115">
        El contenido del producto se proporciona "tal cual". No garantizamos
        resultados específicos derivados del uso del material. No nos hacemos
        responsables de decisiones tomadas basándose en la información
        proporcionada en el producto. El usuario asume toda la responsabilidad
        por la implementación de las recomendaciones.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-116">
        7. Propiedad Intelectual
      </h3>
      <p data-id="element-117">
        Todo el contenido del producto, incluyendo textos, diseños, gráficos y
        plantillas, está protegido por derechos de autor. Queda prohibida
        cualquier reproducción total o parcial sin autorización expresa por
        escrito.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-118">
        8. Modificaciones
      </h3>
      <p data-id="element-119">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor desde su publicación en
        esta página. Las compras realizadas antes de cualquier cambio se regirán
        por los términos vigentes al momento de la transacción.
      </p>

      <h3 className="text-lg font-bold text-navy-dark font-serif" data-id="element-120">
        9. Ley Aplicable
      </h3>
      <p data-id="element-121">
        Estos términos se rigen por las leyes de los Estados Unidos de América.
        Cualquier disputa será resuelta en los tribunales competentes de dicha
        jurisdicción.
      </p>
    </>;
}